import React from 'react';

const faqs = [
  {
    q: '泡泡樂園是免費的嗎？',
    a: '是的！泡泡樂園完全免費，無需下載安裝，直接在瀏覽器中即可遊玩，也不需要註冊帳號。'
  },
  {
    q: '支援哪些遊戲模式？',
    a: '遊戲支援三種模式：時間挑戰（60秒內獲得最高分）、無盡模式（無時間限制挑戰極限）、精準模式（錯過會扣分的高難度挑戰）。'
  },
  {
    q: '如何解鎖成就？',
    a: '遊戲內有25+個成就，包括基礎點擊、連擊、等級、特殊泡泡、分數與挑戰成就，完成特定條件即可自動解鎖。'
  },
  {
    q: '手機也能玩泡泡樂園嗎？',
    a: '當然可以！遊戲完全支援手機與平板電腦，採用響應式設計，在任何裝置上都能流暢遊玩。'
  }
];

const FAQSection = () => {
  return (
    <section
      className="max-w-3xl w-full mx-auto mb-8 px-2"
      aria-labelledby="faq-heading"
    >
      <h2
        id="faq-heading"
        className="text-2xl sm:text-3xl font-bold text-center mb-6 text-gray-800"
      >
        關於泡泡樂園，玩家常問哪些問題？
      </h2>
      <div className="space-y-4">
        {faqs.map((item) => (
          <article
            key={item.q}
            className="bg-white/90 backdrop-blur-sm rounded-2xl p-5 shadow-md hover:shadow-lg transition-shadow"
          >
            <h3 className="text-base sm:text-lg font-bold text-pink-600 mb-2">
              {item.q}
            </h3>
            <p className="text-sm sm:text-base text-gray-700 leading-relaxed">
              {item.a}
            </p>
          </article>
        ))}
      </div>
    </section>
  );
};

export default FAQSection;